import { BaseService } from "./BaseService";

export interface ActivityLogActivity {
  status?: string;
  action: string;
  text?: string;
  rating?: number;
  username?: string;
  feedbackId?: string;
  participantLabel?: string | Record<string, unknown>;
  staffName?: string | Record<string, unknown>;
  guestUsername?: string;
  roomNumber?: string;
  reservationId?: string;
  step?: string;
  type?: string;
  requestId?: string;
  serviceId?: string;
  channelId?: string;
  resolved?: boolean;
}

export const getActivityStreamChannelId = (
  activity: ActivityLogActivity,
): string | null => {
  const fromChannel =
    typeof activity.channelId === "string" ? activity.channelId.trim() : "";
  if (fromChannel) return fromChannel;
  const fromService =
    typeof activity.serviceId === "string" ? activity.serviceId.trim() : "";
  if (fromService) return fromService;
  return null;
};

export interface ActivityLog {
  id: string;
  tenantId: string;
  hotelId: string;
  userId: string;
  roomId?: string;
  bookingId?: string;
  reservationId?: string;
  service: string;
  activity: ActivityLogActivity;
  createdAt: string;
  updatedAt: string;
}

export interface ActivityLogFindAllResponse {
  data: ActivityLog[];
  page: number;
  total: number;
  limit: number;
}

export interface ActivityLogFilters {
  page?: number;
  limit?: number;
  roomId?: string;
  bookingId?: string;
  service?: string[];
  action?: string;
  startDate?: string;
  endDate?: string;
  sort?: string;
}

class ActivityLogService extends BaseService {
  private basePath = "/activity-logs";

  constructor() {
    super();
  }

  findAll(filters?: ActivityLogFilters): Promise<ActivityLogFindAllResponse> {
    return this.get<ActivityLogFindAllResponse>(this.basePath, filters);
  }
}

export const activityLogService = new ActivityLogService();
